import api from '../../utils/api';
import {
    ZALO_OA_GRANT_PERMISSION,
    GET_LIST_OA
} from './types';
import { NotificationManager } from 'react-notifications';

export const grantPermission = () => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/zalo/oa-grant-permission`).then(res => {
            dispatch({ type: ZALO_OA_GRANT_PERMISSION, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg);
            reject(err);
        })
    })
}

export const getListOa = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/zalo', { params: filter }).then(res => {
            dispatch({ type: GET_LIST_OA, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}